import React from "react";
import "./Banner.css";

const Banner = () => {
  return (
    <div className="ImageContainer">
      <div className="overlay"></div>
      <div className="Image">
        <div className="img_holder">
          <img
            src="/assets/images/home_banner.png"
            alt="Banner"
            className="myImage"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
